import React from "react";
import ReactDOM from "react-dom";
import { SicperApp } from "./SicperApp";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

ReactDOM.render(<SicperApp />, document.getElementById("root"));
